import React, { Component, Fragment } from "react";
import { Modal, Button, Row } from "react-bootstrap";
import MainFunc from "../models/MainFunc";
import { withStyles } from "@material-ui/core/styles";
import styles from "../styles/custom-popup.module.scss";
import IconModalCloseKbank from "../images/ico_modal_close_Kbank.svg";
class CustomPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  handleClose = () => {
    this.setState({ show: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleShow = () => {
    this.setState({ show: true });
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <Modal
          className={`${styles.modal} ${classes.root}`}
          size={this.props.size}
          show={this.props.show}
          onHide={this.handleClose}
        >
          {this.props.channel?.css && (
            <img
              className={`${styles.iconCloseModal}`}
              src={IconModalCloseKbank}
              onClick={() => this.handleClose()}
            />
          )}
          <div className={styles.contentModal}>
            {this.props.content && this.props.content}
          </div>

          {this.props.customButtonsfooter && (
            <div className={styles.footer}>
              <Row>
                <Button
                  onClick={() => this.handleClose()}
                  className="mainBtnRadius"
                >
                  {MainFunc.getLabelDtos("L0188") /* ปิด */}
                </Button>
              </Row>
            </div>
          )}
        </Modal>
      </Fragment>
    );
  }
}
const style = {
  root: {
    "& .modal-content": {
      height: "100%",
    },
    "&.modal.show .modal-dialog": {
      height: "100%",
    },
  },
};

export default withStyles(style)(CustomPopup);
